import React, { useEffect, useState } from 'react';
import api from '../api';

export default function DnsDnssec() {
  const [doms, setDoms] = useState([]);
  const [sel, setSel] = useState('');
  const [ds, setDs] = useState('');

  useEffect(() => { api.get('/domains').then(r => setDoms(r.data.filter(d => d.has_dnssec))); }, []);

  const load = async (d) => {
    setSel(d); setDs('Carregando…');
    try {
      const r = await api.get(`/dns/${d}/dnssec`);
      setDs(r.data.dsRecord || '(sem DS — aguarde geração inicial das chaves, ~30s)');
    } catch (e) { setDs(e.response?.data?.error || 'Erro'); }
  };

  const rollover = async () => {
    if (!window.confirm('Iniciar rollover de chaves DNSSEC?')) return;
    try { const r = await api.post(`/dns/${sel}/dnssec/rollover`); alert(r.data.output); }
    catch (e) { alert(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title"><h1>DNS · DNSSEC</h1></div>
      <label>Domínio</label>
      <select value={sel} onChange={e => load(e.target.value)}>
        <option value="">— escolha —</option>
        {doms.map(d => <option key={d.id} value={d.name}>{d.name}</option>)}
      </select>

      {sel && (
        <>
          <h3 style={{marginTop:'1.5rem'}}>Registro DS (cole no registrador)</h3>
          <pre className="code">{ds}</pre>
          <div style={{marginTop:'.6rem'}}>
            <button onClick={() => navigator.clipboard.writeText(ds)} className="secondary">Copiar</button>
            <button onClick={rollover} className="ghost" style={{marginLeft:'.5rem'}}>Rollover</button>
          </div>
        </>
      )}
    </>
  );
}
